import { IS_SAAS } from '../config/edition';

// Единственный источник ролей и классов очереди на фронте. До 20.08.2026 список
// ролей был захардкожен в пяти компонентах — пятое место находилось уже после
// того, как четыре были поправлены.

// Все роли, какие знает продукт. Список нужен целиком для ПОКАЗА: в базе, заведённой
// при нас, может лежать любая из них, и подпись должна найтись.
export const ALL_ROLES = ['user', 'admin', 'service', 'client', 'partner'];

// 🔴 Роли, которые можно НАЗНАЧИТЬ. В издании onprem клиентов и партнёров не бывает:
// клиент — это внешний покупатель нашего SaaS, партнёр — офис на взаимозачёте.
// У клиента в его установке все пользователи свои, поэтому предлагать эти роли в
// админке значит предлагать сущность, которой у него нет (решение Владимира 04.09.2026).
export const ROLES = IS_SAAS
  ? ALL_ROLES
  : ALL_ROLES.filter((r) => r !== 'client' && r !== 'partner');

export const ROLE_LABELS = {
  user: 'Сотрудник',
  admin: 'Администратор',
  service: 'Сервис',
  client: 'Клиент',
  partner: 'Партнёр',
};

// Партнёру — свой оттенок: его будут путать с клиентом, а правила у них разные
// (у клиента жёсткая блокировка по квоте, у партнёра только предупреждение).
export const ROLE_STYLES = {
  user: 'bg-paper-bg text-paper-ink-2',
  admin: 'bg-paper-panel text-paper-ink',
  service: 'bg-slate-100 text-slate-500',
  client: 'bg-emerald-100 text-emerald-700',
  partner: 'bg-paper-panel text-paper-warning',
};

// Сотрудник или внешний клиент. Разделение нужно не для прав, а для того, что
// человеку показывать: канал поддержки в Лензе — внутренний, клиента туда не
// пускают, и ссылка на него у него в интерфейсе вела бы в закрытую дверь.
// Роль неизвестна (токен ещё не разобран) — считаем внешним: показать лишнее
// хуже, чем не показать.
export const isEmployee = (role) => role === 'user' || role === 'admin';

export const QUEUE_CLASSES = ['interactive', 'normal', 'batch'];

export const QUEUE_CLASS_LABELS = {
  interactive: 'Интерактивный',
  normal: 'Обычный',
  batch: 'Пакетный',
};

export const QUEUE_CLASS_ICONS = { interactive: '⚡', normal: '·', batch: '▦' };

// Значения обязаны совпадать с shared/priority_queue.py — там же и меняются.
const ROLE_BASE = { client: 200, partner: 150, user: 100, admin: 100, service: 0 };
const CLASS_MOD = { interactive: 50, normal: 0, batch: -80 };

export function defaultQueueClass(role) {
  return role === 'service' ? 'batch' : 'normal';
}

export function basePriority(role, queueClass) {
  const base = ROLE_BASE[role] ?? 100;
  const mod = CLASS_MOD[queueClass] ?? 0;
  return Math.max(0, base + mod);
}

// hourly — саммаризаций в час (bit-metrics, решение владельца 02.09.2026):
// user 60, partner и service 200, admin без лимита, client — по тарифу.
// Единственный рубеж, который действует и на service.
export const QUOTA_DEFAULTS = {
  user: { audio: 2000, summary: 200, hourly: 60 },
  admin: { audio: null, summary: null, hourly: null },
  service: { audio: null, summary: null, hourly: 200 },
  client: { audio: 120, summary: 50, hourly: null },
  partner: { audio: 10000, summary: 500, hourly: 200 },
};
